module.exports = __webpack_public_path__ + "static/media/solvemoji_cover_easy_medium.5d2bee16.png";